'use client';

import { Suspense } from 'react';
import HotCollectionCardSkeleton from './HotCollectionCardSkeleton';
import LazyLoadComponent from '@fe-news/components/LazyLoadComponent/LazyLoadComponent';
import HotCollectionCard from './HotCollectionCard';

// type

import { HotCollectionCardProps } from '@fe-news/constants/my-track/type';

const HotCollectionCardLazy = ({ id, hotRate, index, isRankingList }: HotCollectionCardProps) => {
  return (
    <Suspense fallback={<HotCollectionCardSkeleton />}>
      <LazyLoadComponent exposureRate={0.1} PlaceholderComponent={<HotCollectionCardSkeleton />}>
        <HotCollectionCard id={id} hotRate={hotRate} index={index} isRankingList={isRankingList} />
      </LazyLoadComponent>
    </Suspense>
  );
};

export default HotCollectionCardLazy;
